import styled, { css } from 'styled-components';

import { media, getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

const CIRCLE_THICKNESS = {
  SM: 4,
  MD: 5,
  LG: 6,
};

export const Wrapper = styled.div`
  width: 25%;
  max-width: 166px;
  text-align: center;
`;

export const CircleWrapper = styled.div`
  position: relative;
  ${({ theme }) => theme.getFluidSpacing('width', 'scale', 19)}
  margin: auto;
  border-radius: 50%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const Svg = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  overflow: visible;
  width: 100%;
  height: 100%;
  padding: ${CIRCLE_THICKNESS.SM / 2}px;

  ${media.from800up`
    padding: ${CIRCLE_THICKNESS.MD / 2}px;
  `}

  ${media.from1280up`
    padding: ${CIRCLE_THICKNESS.LG / 2}px;
  `}
`;

export const Circle = styled.circle.attrs({
  cx: '50%',
  cy: '50%',
  r: '50%',
})`
  fill: none;
  stroke: #fff;
  stroke-width: ${CIRCLE_THICKNESS.SM};
  stroke-linecap: round;

  ${media.from800up`
    stroke-width: ${CIRCLE_THICKNESS.MD};
  `}

  ${media.from1280up`
    stroke-width: ${CIRCLE_THICKNESS.LG};
  `}

  ${({ isValue }) =>
    isValue &&
    css`
      transform: rotate(-90deg);
      transform-origin: center;
      transition: ${({ shouldAnimate }) =>
        shouldAnimate && 'stroke-dashoffset 999ms linear'};
      stroke: ${getThemeColor('hue.green')};
    `}
`;

export const Value = styled(Typography).attrs({
  customAs: 'p',
  variant: 'h4',
})`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0;
  ${({ theme }) => theme.getFluidFont('body6')}
`;

export const Label = styled(Typography).attrs({
  customAs: 'p',
  variant: 'h6',
})`
  ${({ theme }) => theme.getFluidAttribute('margin-top', 0.3, 1.1)}
  margin-bottom: 0;
  ${({ theme }) => theme.getFluidFont('body5')}
  color: ${getThemeColor('bluegrey.70')};
`;
